// Translations for the Communications (announcements/SMS) page.
const communicationsDict = [
  { en: "Title is required", sw: "Kichwa cha habari kinahitajika" },
  { en: "Message is required", sw: "Ujumbe unahitajika" },
  { en: "Select at least one channel", sw: "Chagua angalau njia moja" },
  { en: "Communication created successfully!", sw: "Ujumbe umeundwa kwa mafanikio!" },
  { en: "Unknown error", sw: "Hitilafu isiyojulikana" },
  { en: "Failed to create:", sw: "Imeshindwa kuunda:" },
  { en: "Send this communication now?", sw: "Tuma ujumbe huu sasa?" },
  { en: "Announcement", sw: "Tangazo" },
  { en: "Notification", sw: "Arifa" },
  { en: "Meeting", sw: "Mkutano" },
  { en: "Training", sw: "Mafunzo" },
  { en: "Election", sw: "Uchaguzi" },
  { en: "General", sw: "Jumla" },
  { en: "Communications & Announcements", sw: "Mawasiliano na Matangazo" },
  { en: "Announcements, notices and messages to members", sw: "Matangazo, taarifa na ujumbe kwa wanachama" },
  { en: "New Message", sw: "Ujumbe Mpya" },
  { en: "Sent This Month", sw: "Iliyotumwa Mwezi Huu" },
  { en: "Announcements", sw: "Matangazo" },
  { en: "Meetings", sw: "Mikutano" },
  { en: "All Communications", sw: "Ujumbe Wote" },
  { en: "No Communications Yet", sw: "Hakuna Ujumbe Bado" },
  { en: "Create your first announcement", sw: "Unda tangazo lako la kwanza" },
  { en: "Channels:", sw: "Njia:" },
  { en: "Sent:", sw: "Imetumwa:" },
  { en: "Created:", sw: "Imeundwa:" },
  { en: "Send Now", sw: "Tuma Sasa" },
  { en: "New Communication", sw: "Ujumbe Mpya" },
  { en: "Title", sw: "Kichwa" },
  { en: "Type", sw: "Aina" },
  { en: "Priority", sw: "Umuhimu" },
  { en: "Low", sw: "Chini" },
  { en: "Normal", sw: "Kawaida" },
  { en: "High", sw: "Juu" },
  { en: "Urgent", sw: "Haraka" },
  { en: "Channels", sw: "Njia" },
  { en: "SMS", sw: "SMS" },
  { en: "Email", sw: "Barua pepe" },
  { en: "In-App", sw: "Ndani ya Mfumo" },
  { en: "Message", sw: "Ujumbe" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Create & Send Later", sw: "Unda na Utume Baadaye" },
];

export default communicationsDict;
